import StyleSheet from 'react-native-extended-stylesheet';

export const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonDesktop: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '$space4',
  },
  buttonMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'center',
    height: '100%',
    overflow: 'visible',
    justifyContent: 'center',
  },
  skeleton: {
    color: '$colorBgPrimaryMedium',
  },
  iconDesktop: {
    width: 24,
    height: 24,
    marginRight: '$space2',
  },
  iconMobile: {
    width: 24,
    height: 22,
    marginBottom: '$space05',
  },
  textDesktop: {
    width: 52,
    height: 16,
  },
  textMobile: {
    width: 42,
    height: 12,
  },
});
